import type { AsyncState } from "@react-hookz/web";
import { atom } from "jotai";

import type { AdvertisementConfig } from "~/components/advertisement/hooks";
import { defaultAdvertisementConfig } from "~/components/advertisement/hooks";
import type { IpGeoLocation } from "~/lib/hooks";

export interface App {
  advertisementConfig: AdvertisementConfig;
  ipGeoLocation?: AsyncState<IpGeoLocation | undefined>;
  lockDocumentBodyScroll?: boolean;
}

export const appAtom = atom<App>({
  advertisementConfig: defaultAdvertisementConfig,
  lockDocumentBodyScroll: false,
});
